export enum SubdivisionWarrantyStatusEnum {
  PRODUCTION = 'Production',
  WARRANTY = 'Warranty',
}
